import moment from "moment";

export default {    
    formatDate(date, initialFormat, finalFormat) {
        return moment(date, initialFormat).format(finalFormat);
    },
    firstCharacterCapitalize(string) {
        if(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        return null;
    }
}